import type { FilterMode } from "@/components/filters/Condition/types";
import { FILTER_MODE } from "@/components/filters/Condition/constants";

export type VendorsSlice = {
  inclusionMethod: FilterMode;
  inclusionVendorIds: number[];
  inclusionDepartmentIds: string[];
  inclusionRoleIds: string[];
  inclusionInstallAgeMonths?: { min?: number; max?: number };
  inclusionProductCount?: { min?: number; max?: number };
  excludedVendorIds: number[];
};

export const defaultVendorsSlice: VendorsSlice = {
  inclusionMethod: FILTER_MODE.ANY,
  inclusionVendorIds: [],
  inclusionDepartmentIds: [],
  inclusionRoleIds: [],
  inclusionInstallAgeMonths: undefined,
  inclusionProductCount: undefined,
  excludedVendorIds: [],
};
